import styled from "styled-components";
import { CenterFlexColumn, FlexRow } from "styles/layout";

export const AboutImage = styled.img`
  width: 80%;
`;

export const PersonnelWrapper = styled(FlexRow)`
  align-items: stretch;

  @media (max-width: 800px) {
    flex-direction: column;
  }
`;

export const PersonnelContainer = styled(CenterFlexColumn)`
  flex-basis: 0;
  flex-grow: 1;
  text-align: justify;
  justify-content: stretch;
  border-right: 1px solid gray;
  padding: 0px 15px;

  &:last-child {
    border-right: 1px solid transparent;
  }

  @media (max-width: 800px) {
    border-right: none;
    padding: 0px;
    align-items: flex-start;
    text-align: left;
  }
`;
